import img_1 from 'assets/img/Main Images/Home/Logo design.jpg';
import img_2 from 'assets/img/Main Images/Home/Satellite_Phone_thumb.jpg';
import img_2_1 from 'assets/img/Main Images/Home/Satellite_Phone.jpg';
import img_3 from 'assets/img/Main Images/Home/2d_character_illustration_01.jpg.jpg';
import img_3_1 from 'assets/img/Main Images/Home/2d_character_illustration_02.jpg';
import img_4 from 'assets/img/Main Images/Home/3d character.jpg';
import img_4_1 from 'assets/img/Main Images/Home/Character_Model_01.jpg';
import img_5 from 'assets/img/Main Images/Home/Witch concept art thumb.jpg';
import img_5_1 from 'assets/img/Main Images/Home/Witch concept art.jpg';
import img_6 from 'assets/img/Main Images/Home/Gun.jpg';
import img_6_1 from 'assets/img/Main Images/Home/Gun_01.jpg';
import img_7 from 'assets/img/portfolio/grid/portfolio-grid-7.jpg';
import img_8 from 'assets/img/portfolio/grid/portfolio-grid-8.jpg';
import img_9 from 'assets/img/portfolio/grid/portfolio-grid-9.jpg';
import img_10 from 'assets/img/portfolio/grid/portfolio-grid-10.jpg';
import img_11 from 'assets/img/portfolio/grid/portfolio-grid-11.jpg';
import img_12 from 'assets/img/portfolio/grid/portfolio-grid-12.jpg';

const HomePortFolio = [
    // APPS
    {
        id: '1',
        img: img_1,
        main_img: img_1,
        title: 'Dog Paws Logo',
        category: 'Graphic Design',
        video: true,
        // Replace this URL with any YouTube watch, share, Shorts, or embed URL.
        youtube_url: 'https://www.youtube.com/watch?v=1gyTUHP6ne8'
    },
    {
        id: '2',
        img: img_2,
        main_img: img_2_1,
        title: 'Satellite Phone',
        category: '3D Modeling & Texturing'
    },
    {
        id: '3',
        img: img_3,
        main_img: img_3_1,
        title: '2D Slot Game Design',
        category: '2D Game'
    },
    // BRANDING
    {
        id: '4',
        img: img_4,
        main_img: img_4_1,
        title: 'Character Model',
        category: '3D Modeling & Texturing'
    },
    {
        id: '5',
        img: img_5,
        main_img: img_5_1,
        title: 'Character Design',
        category: 'Concept Art'
    },
    //  Creative
    {
        id: '6',
        img: img_6,
        main_img: img_6_1,
        title: 'Thompson Gun',
        category: '3D Modeling & Texturing',
        // video: true,
        // video_id: '1gyTUHP6ne8',
    },
    // {
    //     id: '7',
    //     img: img_7,
    //     main_img: img_7,
    //     title: 'Stylized Telescope',
    //     category: 'Creative'
    // },
    // {
    //     id: '8',
    //     img: img_8,
    //     main_img: img_8,
    //     title: 'UX Web Design',
    //     category: 'Creative',
    //     video: true,
    //     video_id: 'ty8Y0hCJIYw',
    // },
    // {
    //     id: '9',
    //     img: img_9,
    //     main_img: img_9,
    //     title: 'Magazine Cover',
    //     category: 'Creative'
    // },
    // // Packaging
    // {
    //     id: '10',
    //     img: img_10,
    //     main_img: img_10,
    //     title: 'Visual Identity',
    //     category: 'Packaging'
    // },
    // {
    //     id: '11',
    //     img: img_11,
    //     main_img: img_11,
    //     title: 'UX Web Design',
    //     category: 'Packaging',
    //     video: true,
    //     video_id: 'Xm2VKy2a6aQ',
    // },
    // // Mockup
    // {
    //     id: '12',
    //     img: img_12,
    //     main_img: img_12,
    //     title: 'Magazine Cover',
    //     category: 'Mockup'
    // },
]

export default HomePortFolio;
